// Invert P(Poisson(mean) >= count) = .025. Starting the series at count
// avoids the exp(-mean) underflow in a CDF summed from zero.
export function poissonLowerCount(count) {
    if (!Number.isSafeInteger(count) || count < 0) throw new Error("Invalid session count");
    if (!count) return 0;
    let logFactorial = 0;
    if (count < 16) for (let n = 2; n <= count; n++) logFactorial += Math.log(n);
    const correction = 1 / (12 * count) - 1 / (360 * count ** 3) + 1 / (1260 * count ** 5);
    function tail(mean) {
        const logMass = count < 16 ? -mean + count * Math.log(mean) - logFactorial
            : count * Math.log(mean / count) + (count - mean) - .5 * Math.log(2 * Math.PI * count) - correction;
        if (logMass < -745) return 0;
        let term = 1, sum = 1;
        for (let n = 1; n <= 20000; n++) {
            term *= mean / (count + n);
            sum += term;
            if (term < sum * 1e-14) return Math.exp(logMass) * sum;
        }
        throw new Error("Session counts are too large for this comparison. Narrow the period or scope.");
    }
    let low = 0, high = count;
    for (let i = 0; i < 56; i++) {
        const mid = (low + high) / 2;
        if (tail(mid) > .025) high = mid; else low = mid;
    }
    return (low + high) / 2;
}
